import { type IPropertyDefinition } from '@suvo/shared/property';
import { type ITileDefinition } from '@suvo/shared/tile';

export type IBTileDefinition = ITileDefinition;

function createTileDefinition(name: string, properties: IPropertyDefinition[] = []): IBTileDefinition {
  return {
    name,
    properties,
  };
}

export const definitions: IBTileDefinition[] = [
  createTileDefinition('Chart'),
  createTileDefinition('Table'),
  createTileDefinition('Link Banner'),
  createTileDefinition('Hero Banner V3'),
  createTileDefinition('Presentation'),
  createTileDefinition('Contacts'),
  createTileDefinition('Text Rows'),
  createTileDefinition('Text Columns'),
  createTileDefinition('Icon Columns'),
  createTileDefinition('Free Trial'),
  createTileDefinition('Custom Component'),
  createTileDefinition('Link Banner B'),
  createTileDefinition('rich-text', [
    {
      name: 'text',
      displayName: 'Text',
      type: 'RICHTEXT',
    },
  ]),
];

export type TName = (typeof definitions)[number]['name'];

export const names: TName[] = definitions.map((definition) => definition.name);